/* @jsx h */
import { defineComponent, h } from "vue";
import type { JSX } from "vue/jsx-runtime";

export const RestaurantFormSection = defineComponent<{
  id: string;
  title: string;
  description: string;
  icon: string;
  open: boolean;
  onToggle: () => void;
  render: () => JSX.Element;
}>({
  name: "RestaurantFormSection",
  props: ["id", "title", "description", "icon", "open", "onToggle", "render"],
  setup(props) {
    return () => (
      <section
        data-section={props.id}
        class={[
          "overflow-hidden rounded-xl border border-base-300 bg-base-100 transition-shadow",
          props.open ? "shadow-sm" : "",
        ]}
      >
        <button
          type="button"
          class="flex w-full items-center gap-3 px-4 py-4 text-left transition-colors hover:bg-base-200/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary"
          aria-expanded={props.open}
          aria-controls={`${props.id}-content`}
          onClick={props.onToggle}
        >
          <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
            <span class="material-symbols-outlined text-xl">{props.icon}</span>
          </span>
          <span class="min-w-0 flex-1">
            <span class="block font-semibold text-base-content">
              {props.title}
            </span>
            <span class="mt-0.5 block text-sm text-base-content/60">
              {props.description}
            </span>
          </span>
          <span
            class={`material-symbols-outlined shrink-0 text-base-content/50 transition-transform duration-200 ${
              props.open ? "rotate-180" : ""
            }`}
          >
            expand_more
          </span>
        </button>

        <div
          id={`${props.id}-content`}
          class={[
            "grid transition-[grid-template-rows] duration-200 ease-out",
            props.open ? "grid-rows-[1fr]" : "grid-rows-[0fr]",
          ]}
          aria-hidden={!props.open}
        >
          <div class="overflow-hidden">
            <div class="border-t border-base-300 px-4 py-5 sm:px-5">
              {props.render()}
            </div>
          </div>
        </div>
      </section>
    );
  },
});
